import { searchItemsAutocompleteOptions } from '@metto/http-clients/api';
import { useQuery } from '@metto/http-clients/react-query';
import { useTagsStore } from '#domains/tags';
import { useSearchStore } from '../state';
import { prepareSearchQuery, tokenizeSearchString } from '../utils';

export const useAutocompleteSearchQuery = () => {
  const searchString = useSearchStore(state => state.searchString);
  const allTags = useTagsStore(state => state.tags);

  // Parse search string on every keystroke for autocomplete
  const searchTokens = tokenizeSearchString(searchString);

  // Process tokens into search query params
  const query = prepareSearchQuery(searchTokens, allTags);

  return useQuery({
    ...searchItemsAutocompleteOptions({
      query
    }),
    placeholderData: keepPreviousData => keepPreviousData,
    select: data => {
      const { hits, hitsPerPage, totalHits } = data;

      return {
        items: hits,
        stats: {
          hitsPerPage,
          totalHits
        }
      };
    }
  });
};
